<template>
  <div class="slots">
    <h4>Next Available</h4>
    <div class="alert alert-light bg-light">
      <div class="row justify-content-center">
        <div class="col-6 col-sm-3 col-lg-2 text-center" v-if="!s.provider.image_url.includes('fallback')">
          <img v-bind:src="s.provider.image_url" class="img-fluid rounded-circle mb-3 mb-sm-0 border" width="200" height="200" alt="provider picture" />
        </div>
        <div class="col">
          <div class="d-inline-block">
            <h5 class="d-inline mr-3 mb-1">{{ s.provider.name || "Example Name" }}</h5>
            <strong class="text-nowrap" v-if="s.provider.qualifications != null">{{ s.provider.qualifications }}</strong>
            <table>
              <tbody>
                <tr v-if="s.provider.location != null">
                  <th class="text-muted align-top font-weight-normal" style="min-width: 100px">Location</th>
                  <td>{{ s.provider.location }}</td>
                </tr>
                <tr v-if="s.provider.specialty != null">
                  <th class="text-muted align-top font-weight-normal" style="min-width: 100px">Specialty</th>
                  <td>{{ s.provider.specialty }}</td>
                </tr>
                <tr v-if="s.provider.services != null">
                  <th class="text-muted align-top font-weight-normal" style="min-width: 100px">Services</th>
                  <td>{{ s.provider.services.join(", ") }}</td>
                </tr>
                <tr v-if="isBioVisible && s.provider.bio != null">
                  <th class="text-muted align-top font-weight-normal" style="min-width: 100px">Bio</th>
                  <td>{{ s.provider.bio }}</td>
                </tr>
              </tbody>
            </table>
            <button class="btn btn-sm btn-link text-primary text-decoration-none p-0 w-auto" v-on:click="isBioVisible = !isBioVisible" v-if="isBioVisible">+ Show bio</button>
          </div>
          <a href="#" class="btn btn-primary shadow-sm js-time float-right w-auto d-flex align-items-center pl-3" @click.prevent="$emit('choose', [s])">
            {{ this.displayTime(s.label) }}
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right ml-2 opacity-7" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script charset="utf-8">
export default {
  name: "NextAvailable",
  props: ["s"],
  data() {
    return {
      isBioVisible: false,
    };
  },
  methods: {
    toggleBioVisibility() {
      this.isBioVisible = !this.isBioVisible;
    },
    displayTime(label) {
      // If appointmentTimezoneToUse == "browser", then we need to convert to the browser's timezone
      const timeStart = moment(this.s.ts * 1000);

      const timeStartSlot = appointmentTimezoneToUse == "browser" ? timeStart : timeStart.tz(organizationTimezoneLabel);
      return timeStartSlot.calendar();
    },
  },
};
</script>
